import request from 'api'

export function fetchRecoveries(confirmPasswordKey?: string) {
  return request.get<Recovery[]>('/v1/users/recoveries', { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export function fetchSecurityQuestions(confirmPasswordKey: string) {
  return request.get('/v1/users/securities/questions', { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export function fetchSecurityQuestionsCount() {
  return request.get('/v1/users/questions/count')
}

export function fetchSecurityAnswer(id: string, confirmPasswordKey: string) {
  return request.get(`/v1/users/securities/questions/${id}/answers`, { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export function requestEmailOtp(email: string, languageCode: string, countryCode: string, confirmPasswordKey: string) {
  const requestBody = {
    email: email,
    languageCode: languageCode,
    countryCode: countryCode
  }
  return request.post('/v1/auths/recoveries/methods/emails', requestBody, { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export function checkEmailValidation(email: string, confirmPasswordKey: string) {
  const requestBody = {
    email: email
  }
  return request.post('/v1/validations/accounts', requestBody, { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export function createOrUpdateEmail(email: string, otp: string, sessionId: string, confirmPasswordKey: string) {
  const requestBody = {
    email: email,
    otp: otp,
    sessionId: sessionId
  }
  return request.post('/v1/users/recoveries/methods/email', requestBody, { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export function deleteRecoveryEmail(recoveryId: string, confirmPasswordKey: string) {
  const requestBody = {
    recoveryId: recoveryId
  }
  return request.delete('/v1/users/recoveries/methods/email', {
    data: requestBody,
    headers: { 'x-confirm-key': confirmPasswordKey }
  })
}

export function updateSecurityQuestion(answer: string, questionText: string, questionId: string, confirmPasswordKey: string) {
  const requestBody = {
    answer: answer,
    questionText: questionText,
    questionId: questionId
  }
  return request.post('/v1/users/securities/questions', requestBody, { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export type SecurityQuestion = {
  id: string
  question: string
  hasAnswer: boolean
  answerUpdateRequired: boolean
}

export enum MethodType {
  SMS = 'sms',
  EMAIL = 'email'
}

export type Recovery = {
  methodType: 'sms' | 'email'
  value: string
  id: string
}

export type EmailOtp = {
  key: string
  domainSiteUrl: string
}

export type EmailValidation = {
  status: string
}
